import { AmplitudeProvider } from './AmplitudeProvider.js';
import { BeamerProvider } from './BeamerProvider.js';
import { GTMProvider } from './GTMProvider.js';
import { HotjarProvider } from './HotjarProvider.js';
import { ProviderName } from './Provider.js';

class ProviderFactory {
  createProvider(providerOptions, logger) {
    const providers = {
      [ProviderName.AMPLITUDE]: AmplitudeProvider,
      [ProviderName.BEAMER]: BeamerProvider,
      [ProviderName.GTM]: GTMProvider,
      [ProviderName.HOTJAR]: HotjarProvider
    };
    if (!(providerOptions.name in providers)) {
      throw new Error(`No provider for ${providerOptions.name}`);
    }
    const providerClass = providers[providerOptions.name];
    return new providerClass(providerOptions.key, logger, providerOptions.configuration, providerOptions.commonPayload);
  }
}

export { ProviderFactory };
//# sourceMappingURL=ProviderFactory.js.map
